import React, { useState } from 'react';
import PropTypes from 'prop-types';

// Define the state machine array
const stateMachine = [
  { state: true, color: '#01a7bd', position: '15px' },
  { state: undefined, color: '#808080', position: '0' },
  { state: false, color: '#e0e0e0', position: '-15px' },
  { state: undefined, color: '#808080', position: '0' },
];

const ToggleThreeOptions = ({
  onChange,
  value,
  thumbColor = '#ffffff',
  ...rest
}) => {
  // Initialize the current state index based on the provided value
  const [currentIndex, setCurrentIndex] = useState(
    value === true ? 0 : value === false ? 2 : 1
  );

  // Function to handle toggle click
  const onToggleClick = () => {
    const newIndex = (currentIndex + 1) % stateMachine.length;
    setCurrentIndex(newIndex);
    onChange && onChange(stateMachine[newIndex].state);
  };

  // Get the current state object based on the current index
  const currentState = stateMachine[currentIndex];

  return (
    <div
      style={{
        width: '60px',
        height: '30px',
        backgroundColor: currentState.color,
        borderRadius: '15px',
        position: 'relative',
        cursor: 'pointer',
        transition: 'background-color 0.2s ease-in-out',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      onClick={onToggleClick}
      {...rest}
    >
      <div
        style={{
          width: '26px',
          height: '26px',
          backgroundColor: thumbColor,
          borderRadius: '50%',
          transition: 'transform 0.2s ease-in-out',
          transform: `translateX(${currentState.position})`,
        }}
      />
    </div>
  );
};

ToggleThreeOptions.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.oneOf([true, false, undefined]),
  thumbColor: PropTypes.string,
};

export default ToggleThreeOptions;
